import {TimelineMax, TweenMax, Sine/* , Circ*/, Linear} from 'gsap';
const CustomEase = require('gsap/CustomEase');
const Snap = require('snapsvg');
const InvalidateUtils = require('./svgAnim/InvalidateUtils');
const DrawSectorsUtils = require('./svgAnim/DrawSectorsUtils');

const params = {
    width1: 768,
    height1: 768,
    width2: 858,
    height2: 858,
    width3: 1366,
    height3: 1366
}

const init = function () {
    if (this._initiated) return this;

    this.svg2 = Snap(params.width2, params.height2);
    this.svg3 = Snap(params.width3, params.height3);

    this.svg2.attr({viewBox: `${-params.width2 / 2} ${-params.height2 / 2} ${params.width2} ${params.height2}`});
    this.svg3.attr({viewBox: `${-params.width3 / 2} ${-params.height3 / 2} ${params.width3} ${params.height3}`});

    this.asideVP.appendChild(this.svg2.node);
    this.asideVPMax.appendChild(this.svg3.node);

    _construct(this);

    _permanentInvalidate(this);
    _animationInvalidate(this);
    _cameraInvalidate(this);

    this._stage = '';

    this._initiated = true;
    return this;
};

const _construct = function (diagram) {
    const d = diagram;

    d.sectorsG = d.svg2.g().attr({
        opacity: 0
    });
    d.shadeG = d.svg2.g().attr({
        opacity: 0
    });
    d.blinksG = d.svg2.g();


    // Sectors:
    d.sectorsState = {
        r: 1,
        R: 470 / 2,
        cx: 0,
        cy: 0,
        centerChanged: false,
        rChanged: false,
        c02Ratio: 1 / 470,
        c02Ratio0: 1 / 470,
        c02Ratio1: 240 / 470,
        grRatio: 240 / 470,
        grRatio1: 240 / 470,
        grRatio2: 380 / 470,
        totalShiftRatio: 0.3,
        cGrad1Opacity: 0,
        cGrad2Opacity: 0
    };
    d.sectorsState.data = function (key) {
        if (!this.hasOwnProperty(key)) return undefined;
        return this[key];
    }.bind(d.sectorsState);

    d.sectorsLinesG = DrawSectorsUtils.constructSectors(d.svg2, d.sectorsState.R, 16, 1, 0.3).appendTo(d.sectorsG);
    d.sectorsFineLines = DrawSectorsUtils.constructFineSectors(d.svg2, d.sectorsState.R, 16, 16, 0.1, 0.3).appendTo(d.sectorsG);
    DrawSectorsUtils.changeSectorsRadius(d.sectorsLinesG, d.sectorsState.r);
    DrawSectorsUtils.changeFineSectorsRadius(d.sectorsFineLines, d.sectorsState.r);
    d.c01 = d.svg2.circle(0, 0, 100)
        .attr({
            fill: 'none',
            stroke: 'rgba(255,255,255,0.9)',
            strokeWidth: 0.5,
            strokeLinecap: 'round'
        }).appendTo(d.sectorsG);

    d.c02 = d.svg2.circle(0, 0, 100)
        .attr({
            fill: 'none',
            stroke: 'rgba(255,255,255,0.9)',
            strokeWidth: 0.1,
            strokeLinecap: 'round'
        }).appendTo(d.sectorsG);

    let grnt = d.svg2.gradient('r(0.5, 0.5, 0.5)rgba(0,4,6,0.95)-rgba(0,4,6,0.95):12-rgba(2,49,80,0.28)');
    d.grnt1 = grnt;
    d.cGrad1 = d.svg2.circle(0, 0, 1)
        .attr({
            opacity: 0,
            fill: grnt
        }).appendTo(d.shadeG);

    grnt = d.svg2.gradient('r(0.5, 0.5, 0.5)rgba(0,4,6,0.95)-rgba(0,4,6,0.95):12-rgba(0,5,8,0.91):44-rgba(0,15,25,0.68):72-rgba(2,49,80,0.28)');

    d.grnt2 = grnt;
    d.cGrad2 = d.svg2.circle(0, 0, 1)
        .attr({
            opacity: 0,
            fill: grnt
        }).appendTo(d.shadeG);

    // Dotted circles:
    d.c1 = d.svg2.circle(0, 0, 100)
        .attr({
            opacity: 0,
            fill: 'none',
            stroke: '#00a88d',
            strokeWidth: 1.2,
            strokeLinecap: 'round'
        })
        .data({
            num: 59,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 566 / 2,
            cmRatio: 1 - 566 / 470,
            strokeWidth: 1.2
        });

    d.c2 = d.svg2.circle(0, 0, 100)
        .attr({
            opacity: 0,
            fill: 'none',
            stroke: '#fff',
            strokeWidth: 1,
            strokeLinecap: 'round'
        })
        .data({
            num: 206,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 726 / 2,
            cmRatio: 1 - 726 / 470,
            strokeWidth: 1
        });

    d.c3G = d.svg2.g();
    d.c3 = d.svg2.circle(0, 0, 100)
        .attr({
            opacity: 0,
            fill: 'none',
            stroke: '#ed1c23',
            strokeWidth: 2,
            strokeLinecap: 'round'
        })
        .data({
            num: 134,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 428 / 2,
            cmRatio: 1 - 428 / 470,
            strokeWidth: 1
        })
        .appendTo(d.c3G);

    // Dots under all the layers
    d.cAside1 = d.svg3.circle(0, 0, 100)
        .attr({
            opacity: 0,
            fill: 'none',
            stroke: '#00a88d',
            strokeWidth: 1,
            strokeLinecap: 'round'
        })
        .data({
            num: 90,
            rotation: 0,
            rRatio: 1,
            r: 1,
            R: 858 / 2,
            cmRatio: 1 - 858 / 470,
            strokeWidth: 1
        });

};



const _permanentInvalidate = diagram => {
    const d = diagram;
    // const t = (new Date()).getTime();

    InvalidateUtils.renderDottedCircle(d.c1);
    InvalidateUtils.renderDottedCircle(d.c2);
    InvalidateUtils.renderDottedCircle(d.cAside1);
    InvalidateUtils.syncRotation(d.c1, d.c1);
    InvalidateUtils.syncRotation(d.c2, d.c2);
    InvalidateUtils.syncRotation(d.cAside1, d.cAside1);

    if (d._stage === 'fix' || d._prevStage === 'fix') {

        InvalidateUtils.renderDottedCircle(d.c3);
        InvalidateUtils.syncRotation(d.c3, d.c3);
    }

    // d.lastTime = t;
};

const _animationInvalidate = diagram => {
    const d = diagram;
    // const t = (new Date()).getTime();

    DrawSectorsUtils.updateSectors(d.sectorsLinesG, d.sectorsState);
    DrawSectorsUtils.updateFineSectors(d.sectorsFineLines, d.sectorsState);

    d.c01.attr({
        r: d.sectorsState.r
    });
    d.c02.attr({
        r: d.sectorsState.r * d.sectorsState.c02Ratio
    });

    // Shades
    d.cGrad1.attr({
        r: d.sectorsState.r * d.sectorsState.grRatio
    });

    d.cGrad2.attr({
        r: d.sectorsState.r * d.sectorsState.grRatio
    });

    // d.lastTime = t;
};

const _cameraInvalidate = diagram => {
    const d = diagram;
    // const t = (new Date()).getTime();

    DrawSectorsUtils.updateSectors(d.sectorsLinesG, d.sectorsState);
    DrawSectorsUtils.updateFineSectors(d.sectorsFineLines, d.sectorsState);

    const x1 = d.sectorsState.cx * (1 - d.sectorsState.c02Ratio);
    const y1 = d.sectorsState.cy * (1 - d.sectorsState.c02Ratio);
    const x2 = -d.sectorsState.cx * d.sectorsState.totalShiftRatio;
    const y2 = -d.sectorsState.cy * d.sectorsState.totalShiftRatio;

    // Middle circle shift
    d.c02.attr({
        transform: `translate(${x1}, ${y1})`
    });
    // Total sectors shift
    d.sectorsG.attr({
        transform: `translate(${x2}, ${y2})`
    });

    // Dotted circles
    /* d.c1.attr({
        transform: `translate(${d.sectorsState.cx * d.c1.data('cmRatio')}, ${d.sectorsState.cy * d.c1.data('cmRatio')})`
    });

    d.c2.attr({
        transform: `translate(${d.sectorsState.cx * d.c2.data('cmRatio')}, ${d.sectorsState.cy * d.c2.data('cmRatio')})`
    });

    d.cAside1.attr({
        transform: `translate(${d.sectorsState.cx * d.cAside1.data('cmRatio')}, ${d.sectorsState.cy * d.cAside1.data('cmRatio')})`
    });*/
    if (d._stage === 'fix' || d._prevStage === 'fix') {
        d.c3G.attr({
            transform: `translate(${x2 + d.sectorsState.cx * d.c3.data('cmRatio')}, ${y2 + d.sectorsState.cy * d.c3.data('cmRatio')})`
        });
    }

    // Shades
    d.cGrad1.attr({
        cx: x1 + x2,
        cy: y1 + y2
    });

    d.grnt1.attr({
        fx: 0.5 + 0.5 * d.sectorsState.cx * d.sectorsState.c02Ratio / (d.sectorsState.r * d.sectorsState.grRatio),
        fy: 0.5 + 0.5 * d.sectorsState.cy * d.sectorsState.c02Ratio / (d.sectorsState.r * d.sectorsState.grRatio)
    });

    d.cGrad2.attr({
        cx: x1 + x2,
        cy: y1 + y2
    });

    // d.lastTime = t;
};

const _getStageDiagramState = (diagram, stage, prevStage) => {
    const d = diagram;
    const obj = {
        delay: 0,
        sectorsStateChanged: stage !== prevStage,
        c3Changed: stage === 'fix' || prevStage === 'fix'
    };
    obj.sectorsState = {};
    obj.sectorsState2 = {};

    const b = !__containsStage(prevStage);
    switch (stage) {
        case 'cover':
            obj.sectorsStateChanged = obj.sectorsStateChanged && prevStage !== '';
            obj.sectorsState2.cGrad1Opacity = 0;
            obj.sectorsState2.cGrad2Opacity = 0;
            obj.sectorsState2.duration = 0.05;
            obj.sectorsState2.delay = 2;
            obj.sectorsState2.grRatio = d.sectorsState.grRatio1;
            obj.c1R = 1;
            obj.c2R = 1;
            obj.cAside1R = 1;

            break;

        case 'review':
            obj.sectorsStateChanged = obj.sectorsStateChanged && b;
            obj.sectorsState2.cGrad1Opacity = 1;
            obj.sectorsState2.cGrad2Opacity = 0;
            obj.sectorsState2.duration = b ? 0.05 : 0.75;
            obj.sectorsState2.delay = 0;
            obj.sectorsState2.grRatio = d.sectorsState.grRatio1;
            obj.c1R = d.c1.data('R');
            obj.c2R = d.c2.data('R');
            obj.cAside1R = d.cAside1.data('R');

            break;

        case 'config':
            obj.sectorsStateChanged = obj.sectorsStateChanged && b;
            obj.sectorsState2.cGrad1Opacity = 0;
            obj.sectorsState2.cGrad2Opacity = 1;
            obj.sectorsState2.duration = b ? 0.05 : 0.75;
            obj.sectorsState2.delay = 0;
            obj.sectorsState2.grRatio = d.sectorsState.grRatio1;
            obj.c1R = d.c1.data('R');
            obj.c2R = d.c2.data('R') * 1.09;
            obj.cAside1R = d.cAside1.data('R');

            break;

        case 'fix':
            obj.sectorsStateChanged = obj.sectorsStateChanged && b;
            obj.sectorsState2.cGrad1Opacity = 0;
            obj.sectorsState2.cGrad2Opacity = 1;
            obj.sectorsState2.duration = b ? 0.05 : 0.75;
            obj.sectorsState2.delay = 0;
            obj.sectorsState2.grRatio = d.sectorsState.grRatio2;
            obj.c1R = d.c1.data('R');
            obj.c2R = d.c2.data('R');
            obj.cAside1R = d.cAside1.data('R');

            break;
    }

    if (obj.sectorsStateChanged) {
        obj.sectorsState.on = __containsStage(stage);
        if (obj.sectorsState.on) {
            obj.sectorsState.r = d.sectorsState.R;
            obj.sectorsState.c02Ratio = d.sectorsState.c02Ratio1;
        } else {
            obj.sectorsState.r = 1;
            obj.sectorsState.c02Ratio = d.sectorsState.c02Ratio0;
        }
        obj.sectorsState.rChanged = true;
        obj.delay = 0.95;
    }

    if (obj.c3Changed) {
        obj.c3On = stage === 'fix';
        if (obj.c3On) {
            obj.c3R = d.c3.data('R');
            obj.c3Opacity = 1;
        } else {
            obj.c3R = d.c3.data('R') * 0.4;
            obj.c3Opacity = 0;
        }
    }


    function __containsStage(str) {
        return str.length > 0 && str !== 'cover';
    }

    return obj;
};

const _startLoops = diagram => {
    const d = diagram;
    let tl;

    // LOOP
    d._loopTLs = d._loopTLs || [];
    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1,
        onUpdate: _permanentInvalidate,
        onUpdateParams: [diagram]
    });
    d._loopTLs.push(tl);

    tl.to(d.c2.data(), 126, {
        rotation: -360,
        ease: Linear.easeInOut
    }, 'st');


    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1
    });
    d._loopTLs.push(tl);

    tl.to(d.c1.data(), 92, {
        rotation: 360,
        ease: Linear.easeInOut
    });

    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1
    });
    d._loopTLs.push(tl);

    tl.to(d.c3.data(), 105, {
        rotation: 360,
        ease: Linear.easeInOut
    });

    tl = new TimelineMax({
        delay: 0.15,
        repeat: -1
    });
    d._loopTLs.push(tl);

    tl.to(d.cAside1.data(), 192, {
        rotation: 360,
        ease: Linear.easeInOut
    });
};

const show = function () {
    if (!this._initiated) return this;
    if (this._shown) return this;

    this._shown = true;
    _gotoCurrentStage(this);
    _startLoops(this);

    return this;
};

const hide = function () {
    if (!this._initiated) return this;
    return this;
};

const destroy = function () {
    if (!this._initiated) return this;

    TweenMax.killTweensOf(this.c1.data());
    TweenMax.killTweensOf(this.c2.data());
    TweenMax.killTweensOf(this.c3.data());
    TweenMax.killTweensOf(this.cAside1.data());

    if (this._tl) this._tl.kill();
    this.svg2.remove();
    this.svg3.remove();

    this._shown = false;
    this._initiated = false;

    return this;
};

const goto = function (stage) {
    if (!this._initiated) return this;
    if (this._stage === stage) return this;
    this._prevStage = this._stage;
    this._stage = stage;

    if (this._shown)
        _gotoCurrentStage(this);

    return this;
};

const _setCenter = function (x, y) {
    if (!this._initiated) return this;
    this.sectorsState.centerChanged = true;
    this.sectorsState.cx = x;
    this.sectorsState.cy = y;
    if (this._shown)
        _cameraInvalidate(this);
    return this;
};

const _gotoCurrentStage = diagram => {
    const d = diagram;
    const state = _getStageDiagramState(diagram, diagram._stage, diagram._prevStage);
    const tl = new TimelineMax({
        delay: state.delay,
        onUpdate: () => {
            d.sectorsState.rChanged = state.sectorsState.rChanged;
            d.sectorsState.centerChanged = state.sectorsState.centerChanged;
            _animationInvalidate(diagram);
        }
    });


    // TODO: After transition:
    // diagram._prevStage = diagram._stage;

    // const slight = CustomEase.create('slightBounceOut', 'M0,0 C0.072,0 0.199,0.327 0.24,0.462 0.394,0.97 0.658,1 1,1');
    const slightBounceOut = CustomEase.create('slightBounceOut', 'M0,0,C0.162,0,0.096,1.031,0.316,1.032,0.406,1.032,0.38,1,1,1');
    const bounceOut = CustomEase.create('bounceOut', 'M0,0 C0.162,0 0.097,1.083 0.316,1.084 0.47,1.084 0.406,1 1,1');

    if (state.sectorsStateChanged) {
        const obj = state.sectorsState;
        obj.ease = slightBounceOut;
        tl.to(d.sectorsState, 2.1, obj, 'st');

        tl.to(d.sectorsState, 2.1, {
            grRatio: state.sectorsState2.grRatio,
            ease: slightBounceOut
        }, 'st');


        if (state.sectorsState.on) {
            tl.to([d.sectorsG.node, d.shadeG.node], 0.1, {
                opacity: 1
            }, 'st');
            tl.to([d.c1.node, d.c2.node, d.cAside1.node], 0.2, {
                opacity: 1
            }, 'st+=' + 0.15);
        } else {
            tl.to([d.sectorsG.node, d.shadeG.node], 0.1, {
                opacity: 0
            }, 'st+=' + 2);
            tl.to([d.c1.node, d.c2.node, d.cAside1.node], 0.2, {
                opacity: 0
            }, 'st+=' + 1);
        }


    } else {
        tl.to(d.sectorsState, 1.6, {
            grRatio: state.sectorsState2.grRatio,
            ease: Sine.easeInOut
        }, 'st');
    }

    tl.to(d.cGrad1.node, state.sectorsState2.duration, {
        opacity: state.sectorsState2.cGrad1Opacity
    }, 'st');

    tl.to(d.cGrad2.node, state.sectorsState2.duration, {
        opacity: state.sectorsState2.cGrad2Opacity
    }, 'st');

    tl.to(d.c1.data(), 2.45, {
        r: state.c1R,
        ease: bounceOut
    }, 'st');

    tl.to(d.c2.data(), 2.57, {
        r: state.c2R,
        ease: bounceOut
    }, 'st');

    tl.to(d.cAside1.data(), 2.75, {
        r: state.cAside1R,
        ease: bounceOut
    }, 'st');

    if (state.c3Changed) {
        tl.to(d.c3.data(), 2.37, {
            r: state.c3R,
            ease: slightBounceOut
        }, 'st+=' + 0.15);

        tl.to(d.c3.node, 2.37, {
            opacity: state.c3Opacity,
            ease: slightBounceOut
        }, 'st+=' + 0.15);
    }


    d._tl = tl;
};


module.exports = (asideVP, asideVPMax) => {
    const Diagram = {};
    Diagram.asideVP = asideVP;
    Diagram.asideVPMax = asideVPMax;

    Diagram.init = init.bind(Diagram);
    Diagram.destroy = destroy.bind(Diagram);
    Diagram.show = show.bind(Diagram);
    Diagram.hide = hide.bind(Diagram);
    Diagram.goto = goto.bind(Diagram);
    Diagram.setCenter = _setCenter.bind(Diagram);

    return Diagram;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/CentralDiagramBack.js